export default __webpack_public_path__ + "17aac1f5c659544db17cb5502ab54628.png";